module.exports = __webpack_public_path__ + "static/JetBrainsMono-Medium-902f1cf630c9adcb7ae5408ad36243b0.ttf";